import React from "react";
import "../../styles/Css/Features.css";

const FeaturesSection = () => {

    const features = [
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                </svg>
            ),
            title: 'AI Contract Intelligence',
            description: 'Automatically analyze and extract key terms, dates, contingencies, and important clauses from real estate contracts and documents.',
            image: '/images/feature-contract.png'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                </svg>
            ),
            title: 'AI Email Summaries & Smart Replies',
            description: 'Get instant summaries of long email threads and AI-generated response suggestions to keep your communication flowing smoothly.',
            image: '/images/feature-email.png'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z" />
                    <path d="M19 3h-4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
                </svg>
            ),
            title: 'Automated Tasks & Checklists',
            description: 'Let AI create and manage your task lists with automatic reminders and deadline tracking to stay on top of every detail.',
            image: '/images/feature-tasks.png'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="9" y1="21" x2="9" y2="9" />
                </svg>
            ),
            title: 'CRM & Platform Integrations',
            description: 'Seamlessly connect with your existing CRM, email, calendar, and other tools you already use for a unified workflow.',
            image: '/images/feature-crm.png'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                    <line x1="9" y1="9" x2="9.01" y2="9" />
                    <line x1="15" y1="9" x2="15.01" y2="9" />
                </svg>
            ),
            title: 'Client Portal',
            description: 'Give clients a dedicated space to review documents, track progress, and communicate - all in one professional portal.',
            image: '/images/feature-portal.png'
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="20" x2="18" y2="10" />
                    <line x1="12" y1="20" x2="12" y2="4" />
                    <line x1="6" y1="20" x2="6" y2="14" />
                </svg>
            ),
            title: 'Analytics & Reporting',
            description: 'Track your transaction performance with insightful dashboards and reports to understand your business better.',
            image: '/images/feature-analytics.png'
        }
    ];

    return (
        <section className="features section">
            <div className="container">
                <h2 className="section-title">AI-Powered Features</h2>
                <p className="section-subtitle">
                    Intelligent automation that works for you, 24/7.
                </p>
                <div className="features__grid">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-card">
                            <div className="feature-card__icon" style={{ cursor: "pointer" }}>
                                {feature.icon}
                            </div>
                            <h3 className="feature-card__title">{feature.title}</h3>
                            <p className="feature-card__description">{feature.description}</p>
                            <div className="feature-card__preview" style={{ cursor: "pointer" }}>
                                <div className="feature-card__preview-placeholder">
                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                        <circle cx="8.5" cy="8.5" r="1.5" />
                                        <polyline points="21 15 16 10 5 21" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;